import { RESOURCE_NAME as BENEFITS } from '@esentai/core/features/benefits/consts';
import { permit } from '@esentai/core/policy-dsl';

import { GIVE_OUT } from '@/features/benefitGiveOutPage/consts/permissions';

export default [permit(BENEFITS, [GIVE_OUT])];
